import React, { useState } from "react";
import s from "./Header.module.scss";
import ReusableDrawer from "../../../../../../global components/Drawer/ReuseableDrawer";
import NewMemberForm from "../NewMemberForm";
import NewRoleForm from "../NewRoleForm";
import { Tooltip } from "antd";
import { Roles } from "../../../../../../libs/Utils/Types/Teams";
import { swrFetcher } from "../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import useSWR from "swr";
type headerProp = {
  unauthorized: boolean;
  mutate: () => void;
};
function Header({ unauthorized, mutate }: headerProp) {
  const token=UseAuthToken()
  const [open, setOpen] = useState<boolean>(false);
  const [openNewRole, setOpenNewRole] = useState<boolean>(false);
  const handleMemberFormDrawer = () => {
    setOpen((prev) => !prev);
  };
  const handleNewRoleFormDrawer = () => {
    setOpenNewRole((prev) => !prev);
  };
  const {
   
    mutate:mutateRoles,
  } = useSWR<{data:Roles[]}, any, any>(
    token ? ["api/admin/team/roles", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      shouldRetryOnError: false, // Disable retrying on errors
    }
  );
  return (
    <>
      <ReusableDrawer
        Open={openNewRole}
        handleOpen={handleNewRoleFormDrawer}
        title="Create new role"
      >
        <NewRoleForm handleOpen={handleNewRoleFormDrawer} mutate={mutateRoles} />
      </ReusableDrawer>
      <ReusableDrawer
        Open={open}
        handleOpen={handleMemberFormDrawer}
        title="Invite new member"
      >
        <NewMemberForm handleOpen={handleMemberFormDrawer} mutate={mutate}/>
      </ReusableDrawer>
      <div className={s.wrapper}>
        <div className={s.titles}>
          <h3 className={s.title}>Team </h3>
          <h4 className={s.subtitle}>Manage all team members here</h4>
        </div>
        <div className={s.btnGroup}>
          <Tooltip title={unauthorized && "Unauthorized"}>
            <button
              disabled={unauthorized}
              className={s.createBtn}
              onClick={handleNewRoleFormDrawer}
            >
              Create new role
            </button>
          </Tooltip>
          <Tooltip title={unauthorized && "Unauthorized"}>
            <button
              disabled={unauthorized}
              className={s.inviteBtn}
              onClick={handleMemberFormDrawer}
            >
              Invite new member
            </button>
          </Tooltip>
        </div>
      </div>
    </>
  );
}

export default Header;
